<!--
 * @Desc: 
 * @Author: lc
 * @Date: 2023-04-24 16:09:24
 * @LastEditors: lc
 * @LastEditTime: 2023-05-11 11:47:19
-->
<template>
  <div class="config">
    <Form :model="config"
          action="javascript:void(0)">
      <FormItem label="积分兑换规则"
                label-position="top">
        <Input v-model="config.points_rule"
               type="number"
               style="width:100px"
               placeholder="请输入数字..."></Input>
        <Alert type="error"
               style="width:350px;top: 8px;">其他平台n积分兑换时代记忆平台1积分</Alert>
      </FormItem>
      <FormItem label="消费规则">
        <Input v-model="config.plat_exchange_points_bili"
               type="number"
               style="width:100px"
               placeholder="请输入数字..."></Input>
        <Alert type="error"
               style="width:350px;top: 8px;">n积分兑换一元</Alert>
      </FormItem>
      <FormItem>
        <Button type="primary"
                @click="handleSubmit()">提交</Button>
      </FormItem>
    </Form>
  </div>
</template>
    
    
    <script>
export default {
  name: 'config',
  data () {
    return {
      config: {
        points_rule: "",
        plat_exchange_points_bili: "100",
      },
    }
  },
  created: function () {
    this.getConfig();
  },
  methods: {
    handleSubmit (name) {
      this.$api.config.edit(this.config).then(res => {
        if (res.code == 200) {
          this.$Message.success('修改成功...');
        }
      });
    },
    getConfig: function () {
      this.$api.config.detail().then(res => {
        this.config = res.result;
      });
    },

  }
}
    </script>